import React from 'react';
import styled from 'styled-components';

interface PromotionAlertProps {
  isOpen: boolean;
  onClose: () => void;
  content: string;
}

const PromotionAlert: React.FC<PromotionAlertProps> = ({
  isOpen,
  onClose,
  content,
}) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay>
      <ModalContainer>
        <ModalContent>{content}</ModalContent>
        <ModalDivider />
        <ConfirmButton onClick={onClose}>확인</ConfirmButton>
      </ModalContainer>
    </ModalOverlay>
  );
};

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

const ModalContainer = styled.div`
  width: 328px;
  background-color: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
`;

const ModalContent = styled.div`
  padding: 32px 16px;
  color: #4b4b4b;
  text-align: center;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
`;

const ModalDivider = styled.div`
  height: 1px;
  background-color: #e5e8ea;
`;

const ConfirmButton = styled.button`
  width: 100%;
  padding: 16px;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #008aff;
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: center;
`;

export default PromotionAlert;
